var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('beast-header'),_c('router-view'),_c('beast-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }